<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row mt-4">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">
                {{ isEdit ? "Edit" : "Add" }} Testimonial
              </h3>
            </div>
            <v-stepper v-model="e1" light>
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1" editable
                  >Testimonial Details</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step v-if="!isEdit" :complete="e1 > 2" step="2"
                  >Testimonial Image</v-stepper-step
                >
                <v-stepper-step
                  v-if="isEdit"
                  :complete="e1 > 2"
                  @click="updateValidate"
                  editable
                  step="2"
                  >Testimonial Image</v-stepper-step
                >
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content class="v-form-body" step="1">
                  <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    enctype="multipart/form-data"
                    class="body-content"
                  >
                    <v-row>
                      <v-col cols="6">
                        <label class="form-control-label">
                          Title
                          <span class="red--text">*</span>
                        </label>
                        <ValidationProvider
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="testimonial.title"
                            placeholder="Enter Title"
                            solo
                            :rules="[(v) => !!v || 'Title is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                            :error-messages="errors"
                          />
                        </ValidationProvider>
                      </v-col>

                      <v-col cols="6">
                        <label class="form-control-label">
                          Name
                          <span class="red--text">*</span>
                        </label>
                        <ValidationProvider
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="testimonial.name"
                            placeholder="Enter Name"
                            solo
                            :rules="[(v) => !!v || 'Name is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                            :error-messages="errors"
                          />
                        </ValidationProvider>
                      </v-col>

                      <v-col cols="12">
                        <label class="form-control-label">
                          Speciality
                          <span class="red--text">*</span>
                        </label>
                        <ValidationProvider
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="testimonial.speciality"
                            placeholder="Enter Speciality"
                            solo
                            :rules="[(v) => !!v || 'Speciality is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                            :error-messages="errors"
                        /></ValidationProvider>
                      </v-col>

                      <v-col cols="12">
                        <label class="form-control-label">
                          Bio
                          <span class="red--text">*</span>
                        </label>
                        <v-textarea
                          v-model="testimonial.bio"
                          solo
                          label="Bio"
                          counter
                          maxlength="200"
                          auto-grow
                          :rules="[(v) => !!v || 'Bio is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                          rows="3"
                        ></v-textarea>
                      </v-col>

                      <v-col class="text-right" cols="12">
                        <v-btn
                          color="#989898"
                          class="mr-4 white--text"
                          @click="cancel"
                          >Cancel</v-btn
                        >
                        <v-btn
                          v-if="!isEdit"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="saveValidate"
                          >Next</v-btn
                        >
                        <v-btn
                          v-if="isEdit"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="updateValidate"
                          >Next</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>

                <v-stepper-content class="v-form-body" step="2">
                  <v-row>
                    <v-col
                      :class="$vuetify.breakpoint.mdAndUp ? 'col-6' : 'col-12'"
                      class="pa-5"
                    >
                      <v-card>
                        <v-card-title>
                          <span class="Subtitle 1"
                            >Upload Testimonial Image</span
                          >
                        </v-card-title>
                        <v-card-text>
                          <vue-dropzone
                            class="vue-dropzone-box"
                            ref="myVueDropzone"
                            id="dropzone"
                            :destroyDropzone="false"
                            :options="dropzoneOptions"
                            @vdropzone-sending="beforecomplete"
                            @vdropzone-success="aftercomplete"
                            @vdropzone-mounted="uploadedImage"
                            @vdropzone-removed-file="removeFile"
                            :useCustomSlot="true"
                            :useCustomDropzoneOptions="true"
                          >
                            <div class="dropzone-custom-content">
                              <img src="@/assets/images/ImageUpload.svg" />
                              <h3 class="font-weight-light ma-0">
                                Drag and drop here to upload
                              </h3>
                              <h3 class="font-weight-light ma-0">Or</h3>
                              <h3 class="dropzone-custom-title">Browse</h3>
                            </div>
                          </vue-dropzone>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-col class="text-right" cols="12">
                    <v-btn
                      color="#989898"
                      class="mr-4 white--text"
                      @click="cancel"
                      >Cancel</v-btn
                    >
                    <v-btn
                      :disabled="!valid"
                      color="#344452"
                      class="white--text"
                      :loading="loading"
                      @click="save"
                      >{{ isEdit ? "Update" : "Save" }}</v-btn
                    >
                  </v-col>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CommonSection from "@/components/CommonHeader";
import { testimonialsService, MediaService } from "@/services";
import vue2Dropzone from "vue2-dropzone";
import { ValidationProvider } from "vee-validate";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import {
  MEDIATYPE_THUMBNAIL,
  CLINIC_IMAGE_WIDTH,
  CLINIC_IMAGE_HEIGHT,
} from "@/constants";
import { ImageValidateMixin } from "@/mixins";

export default {
  name: "AddTestimonial",
  components: {
    CommonSection,
    ValidationProvider,
    vueDropzone: vue2Dropzone,
  },
  mixins: [ImageValidateMixin],
  data() {
    var self = this;
    return {
      e1: 1,
      loading: false,
      valid: true,
      testimonial: {
        title: null,
        name: null,
        speciality: null,
        bio: null,
      },
      isEdit: false,
      media: [],
      testimonialId: null,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_SERVERURL}media`,
        chunking: true,
        addRemoveLinks: true,
        autoProcessQueue: true,
        maxFilesize: 2, // MB
        thumbnailWidth: 300,
        maxFiles: 1,
        headers: {
          Authorization: `Bearer ${store.state.user.token}`,
        },
        dictFileTooBig:"File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        acceptedFiles: "image/*",
        init() {
          this.on("thumbnail", (file) => {
            self.validateBannerDimension(
              file,
              CLINIC_IMAGE_WIDTH,
              CLINIC_IMAGE_HEIGHT
            );
          });
          this.on("addedfile", file => {
            if (file.size > 1024 * 1024 * 2) {
              // not more than 2mb
              this.removeFile(file);
            }
          });
          this.on("maxfilesexceeded", function(file) {
              this.removeAllFiles();
              this.addFile(file);
           });
        },
        accept(file, done) {
          self.showError(file, CLINIC_IMAGE_WIDTH, CLINIC_IMAGE_HEIGHT, done);
        },
      },
      editorOption: {
        theme: "snow",
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    beforecomplete(file, xhr, formData) {
      formData.append("mediaType", "image");
      formData.append("moduleType", "testimonial");
      formData.append("mediaSubType", "file");
      formData.append("imageType", MEDIATYPE_THUMBNAIL);
      formData.append("moduleId", this.testimonialId);
    },
    aftercomplete() {
      this.$store.dispatch(
        "user/setSnack",
        "Testimonial Image uploaded successfully!"
      );
      this.$store.dispatch("user/setType", "info");
    },
    removeFile(file) {
      if (file.size > 1024 * 1024 * 2) {
        this.$store.dispatch(
          "user/setSnack",
          "Upto 2MB File size is allowed"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.deletePicture(file);
    },
    async deletePicture(file) {
      try {
        if (file) {
          let mediaId = this.media.filter((media) => {
            if (media.mediaType == "image" && media.name == file.name) {
              return media._id;
            }
          });
          if (mediaId.length > 0) {
            const response = await MediaService.deleteMedia({
              id: mediaId[0]._id,
              body: {
                moduleType: "testimonial",
                moduleId: this.testimonialId,
              },
            });
            if (response) {
              this.$store.dispatch(
                "user/setSnack",
                "Testimonial image deleted successfully!"
              );
              this.$store.dispatch("user/setType", "info");
            }
          }
        }
      } catch (error) {
        this.$store.dispatch("user/setSnack", error);
        this.$store.dispatch("user/setType", "error");
      }
    },
    cancel() {
      this.$router.push("/testimonials");
    },
    async saveValidate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await testimonialsService.create(this.testimonial);
          this.loading = false;
          if (response) {
            this.e1 = 2;
            this.testimonialId = response.data.id;
            this.$store.dispatch(
              "user/setSnack",
              "Testimonial added successfully!"
            );
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async updateValidate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await testimonialsService.update({
            id: this.$route.params.id,
            object: this.testimonial,
          });
          this.loading = false;
          if (response) {
            this.e1 = 2;
            this.testimonialId = response.data.id;
            this.$store.dispatch(
              "user/setSnack",
              "Testimonial updated successfully!"
            );
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          this.loading = false;
          this.$router.push("/testimonials");
          this.$store.dispatch(
            "user/setSnack",
            `Testimonial ${this.isEdit ? "updated" : "added"} successfully!`
          );
          this.$store.dispatch("user/setType", "info");
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async getData() {
      if (this.$route.params.id !== "create") {
        await this.getTestimonialData();
        await this.uploadedImage();
        this.isEdit = true;
      }
    },
    async getTestimonialData() {
      const testimonial = await testimonialsService.get(this.$route.params.id);
      this.testimonial.name = testimonial.data.data[0].name;
      this.testimonial.title = testimonial.data.data[0].title;
      this.testimonial.bio = testimonial.data.data[0].bio;
      this.testimonial.speciality = testimonial.data.data[0].speciality;
      this.media = testimonial.data.data[0].media;
    },
    uploadedImage() {
      if (this.media && this.media.length > 0) {
        this.media.filter((media) => {
          if (media.mediaType == "image") {
            var file = {
              size: media.size,
              name: media.name,
              type: media.type,
            };
            this.$refs.myVueDropzone.manuallyAddFile(file, media.url);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.main-content .navbar-top {
  display: none !important;
}
</style>
